export default {
    common: {
        email: 'Correo electrónico',
        LoginBtn: 'Iniciar sesión',
        SignUpBtn: 'Regístrate',
        SubmitBtn: 'Enviar',
        ExitBtn: 'Salir de',
        LogoutBtn: 'Cerrar sesión'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Por favor, compruebe su correo electrónico para el código de verificación.',
        VerificationCode: 'Código de verificación'
    },
    header: {
        OrderHistory: 'Historial de pedidos',
        MYACCOUNT: 'MI CUENTA',
        WelcomeBack: 'Bienvenido'
    },
    detail: {
        TotalOrders: 'Pedidos totales',
        TotalProducts: 'Productos totales',
        WonderlandPoints: 'Puntos Wonderland',
        APMCredits: 'APM Crédito',
        ExpireOn: 'Expiración',
        NoAPMCredits: 'No hay crédito apm',
        CreditsLoading: 'Carga de créditos',
        Orders: 'Pedido',
        Online: 'En línea',
        Boutique: 'Boutique',
        Total: 'Total',
        Delivered: 'Entregado',
        NoData: 'Sin Datos',
        Status: 'Estado',
        item: 'artículo',
        items: 'artículos'
    },
    panel: {},
    entry: {
        Client: 'Cliente',
        OrderDate: 'Fecha de pedido',
        DeliverDate: 'Fecha de entrega',
        Description: 'Descripción',
        Total: 'Total'
    },
    board: {
        Order: 'Pedido',
        Date: 'Fecha',
        Total: 'Total'
    },
    order: {
        OrderID: 'ID Pedido',
        PurchasePlace: 'Ubicación',
        PurchaseDate: 'Fecha de compra',
        TotalPrice: 'Precio total',
    },
    product: {
        Name: 'Nombre',
        SKU: 'SKU',
        Size: 'Talla',
        Quantity: 'Cantidad',
        Price: 'Precio',
        WarrantyUntil: 'Garantía hasta',
    },
    ordersLayout: {
            pageTitleOrders: "Pedidos",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "Inicio",
            navProfile: "Perfil",
            navOrders: "Pedidos",
            navWonderland: "Wonderland",
            navWishlist: "Lista de deseos",
            navContactUs: "Contáctenos",
            navExchangeReturn: "Cambio y devolución",
            footerExchangePolicy: "Política de cambio y devolución",
            footerShipping: "Envío",
            footerPrivacy: "Política de privacidad",
            footerTerms: "Términos del servicio",
            footerRegion: "Francia",
            menuTrackOrder: "Seguir pedido",
            menuViewDetails: "Ver detalles",
            back: "Volver",
            orderNumberHeading: "Número de pedido {{id}}",
            itemsCount_one: "{{count}} artículo",
            itemsCount_other: "{{count}} artículos",
            emptyOrders: "Sin pedidos",
            invoiceSoon: "Próximamente",
            storeAddressPending: "Dirección disponible próximamente",
            skuPrefix: "SKU",
            statusLabel: "Estado",
            productNameFallback: "Producto",
            tabOnline: "EN LÍNEA",
            tabOffline: "FUERA DE LÍNEA",
            learnMore: "MÁS INFORMACIÓN",
            redeemInStore: "CANJEAR EN TIENDA",
            dateLabel: "Fecha",
            itemSingular: "Artículo",
            statusConfirmed: "Confirmado el",
            purchaseDateLabel: "Fecha de compra:",
            monthJan: "Ene",
            monthFeb: "Feb",
            monthMar: "Mar",
            monthApr: "Abr",
            monthMay: "May",
            monthJun: "Jun",
            monthJul: "Jul",
            monthAug: "Ago",
            monthSep: "Sept",
            monthOct: "Oct",
            monthNov: "Nov",
            monthDec: "Dic",
            storeLabel: "Tienda",
            downloadInvoice: "Descargar factura",
            warrantyExpires: "La garantía vence el",
            sizeLabel: "Talla",
            subtotalLabel: "Subtotal",
            totalLabel: "Total",
        },
}


// WEBPACK FOOTER //
// ./src/locales/es/index.js